export default {
    methods: {
        /**
         * addToSequence represents everything that should be displayed to the user (selectable or base)
         * @param {object} event is the initial event from user interaction (calendar, lesson panel...)
         * @param {object} formData any form data to be set
         * @param {object} componentData any component data to be set
         * @see BookingControls.js
         * @see BookingSource.js
         * @see CreateLesson.vue
         * *** Must call $controls_setStepData to set data and build stepHistory ***
         * *** If any item in addToSequence will affect stepSequence length, a new option should be created ***
         * *** Any methods called from BookingSource.js need to pass a 0 to $controls_setStepData() ***
         */

        /**
         * *** Client options ***
         */

        /**
         * @see mySchedule.vue
         * @see lessonPanels.vue
         */
        $_options_clientDirectRescheduleSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            if (!this.bookingSource.isMySchedule) return;

            let canExchangePass = event?.group_event?.can_exchange_passes;

            let addToSequence = [
                {
                    name: "somethingNew",
                    hide: canExchangePass,
                },
                {
                    name: "substitutePass",
                    hide: !canExchangePass,
                },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        /**
         * @see mySchedule.vue
         * @see clientBookingPanel.vue
         */
        async $_options_selfServeSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            if (!this.bookingSource.isSelfServe) return;

            /*await this.$_apis_getCancelledLessons(
                event.type?.reschedule,
                formData.student
            );*/

            if (
                !this.apiCancelledLessons["totalMinutes"] &&
                !this.apiCancelledLessons["totalPasses"]
            ) {
                this.form.student = formData.student;
                this.form.type = event.type;
                if (this.showNoRescheduleAlert(formData.student)) return;
            }

            let addToSequence = [
                { name: "student", hide: formData.student },
                {
                    name: "credit",
                    hide: event.type?.dropIn || event.type?.assessment,
                    hideProgress: !!formData.student,
                    hideCancelBtn: !!formData.student,
                    header: !!formData.student,
                },
                {
                    name: "purchaseOption",
                    hide: !event.type?.dropIn,
                    hideProgress: !!formData.student,
                    hideCancelBtn: !!formData.student,
                    header: !!formData.student,
                },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        /*$_options_clientPurchaseOptionStep(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                {
                    name: "purchaseOption",
                },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientCreditStep(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                {
                    name: "somethingNew",
                    hideProgress: false,
                    hideCancelBtn: false,
                    header: false,
                },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },*/

        $_options_clientAssessmentSteps(
            event = {},
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                { name: "location" },
                { name: "online" },
                { name: "instrument" },
                { name: "startDate" },
                { name: "startTime" },
                //{ name: "teacher" },
                //{ name: "studentInfo" },
                //{ name: "room" },
                //{ name: "clientInfo" },
                { name: "experience" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_guestAssessmentSteps(
            event = {},
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                { name: "location", noIndex: true },
                { name: "instrument", noIndex: true },
                //{ name: "purchaseOption" },
                //{ name: "billingUser" },
                { name: "online" },
                { name: "startDate" },
                { name: "startTime" },
                //{ name: "experience" },
                //{ name: "teacher" },
                //{ name: "studentInfo" },
                //{ name: "room" },
                //{ name: "clientInfo" },
                //{ name: "experience" },
                //{ name: "confirm" }
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );

            this.form.location = event.guest.selectedLocation;
            this.form.instrument = event.guest.selectedInstrument;
        },
        $_options_convertGuestSteps(
            event = {},
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                //{ name: "clientInfo" },
                //{ name: "experience" },
                { name: "payment" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientSomethingNewSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                {
                    name: "somethingNew",
                    hideProgress: false,
                    hideCancelBtn: false,
                    header: false,
                },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientRescheduleLessonSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "duration" },
                { name: "location" },
                { name: "online" },
                { name: "instrument" },
                {
                    name: "teacher",
                    hide: !formData.teacher && !this.$page.props.staffView,
                },
                { name: "startDate" },
                { name: "startTime" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientRescheduleGroupEventSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "duration" },
                { name: "location" },
                { name: "online" },
                { name: "templateEvent" },
                //{ name: "instrument" },
                {
                    name: "teacher",
                    hide: !formData.teacher && !this.$page.props.staffView,
                },
                { name: "startDate" },
                { name: "startTime" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientChangeRescheduleSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "duration", noIndex: true },
                { name: "location" },
                { name: "online" },
                { name: "instrument" },
                { name: "startDate" },
                { name: "startTime" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientSubstitutePassSteps(
            event,
            formData,
            componentData,
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                {
                    name: "substitutePass",
                    hideProgress: false,
                    header: false,
                    hideCancelBtn: false,
                },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_clientRescheduleClassSteps(
            event,
            formData,
            componentData,
            sourceStep = this.stepNumber
        ) {
            let inStudioOnly = event.group_event.in_studio_only;

            let addToSequence = [
                { name: "selectClass" },
                { name: "online", hide: inStudioOnly },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },

        /**
         * *** Staff options ***
         */

        $_options_staffTypeSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                {
                    name: "type",
                },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_newHoldSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "repeating" },
                { name: "duration" },
                { name: "teacher" },
                { name: "startDate" },
                { name: "startTime" },
                { name: "room" },
                { name: "experience" },
                { name: "confirm" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        /*$_options_calendarGroupEventSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                //{ name: "substitutePass" },
                { name: "eventType" },
                { name: "templateEvent" },
                //{name: "location"},
                { name: "repeating" },
                { name: "online" },
                { name: "duration" },
                {
                    name: "teacher",
                    noIndex: !!componentData.assignment && !event.teacherView,
                },
                { name: "startDate" },
                { name: "startTime" },
                { name: "room" },
                { name: "capacity" },
                { name: "confirm" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },*/
        $_options_groupEventSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                { name: "eventType" },
                { name: "templateEvent" },
                { name: "repeating" },
                { name: "occurrences" },
                { name: "online" },
                { name: "duration" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_templateEventSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                //{ name: "registrationOnly", hide: !event.registration_event },
                {
                    name: "teacher",
                    noIndex:
                        !!componentData.assignment &&
                        !event.teacherView &&
                        this.bookingSource.isCalendar,
                },
                { name: "startDate" },
                { name: "startTime" },
                { name: "room" },
                { name: "capacity" },
                { name: "confirm" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_calendarRegistrationEventSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "startDate" },
                { name: "startTime" },
                { name: "teacher" },
                { name: "room" },
                { name: "capacity" },
                { name: "confirm" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_newRegistrationEventSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "startDate" },
                { name: "startTime" },
                { name: "teacher" },
                { name: "room" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_newRegistrationOffsiteSteps(
            event = {},
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                { name: "offSiteLocation" },
                { name: "capacity" },
                { name: "confirm" },
            ];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_newRegistrationOnsiteSteps(
            event = {},
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            //this.offSiteLocationValid = true;

            let addToSequence = [{ name: "capacity" }, { name: "confirm" }];
            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_newLessonSteps(
            event = {},
            formData = {},
            componentData = {},
            sourceStep = this.stepNumber
        ) {
            let addToSequence = [
                //{ name: "assessmentType" },
                { name: "student" },
                { name: "purchaseOption" },
                { name: "billingUser" },
                { name: "duration" },
                { name: "location" },
                { name: "online" },
                { name: "instrument" },
                { name: "teacher" },
                { name: "startDate" },
                { name: "startTime" },
                { name: "room" },
                { name: "experience" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_calendarLessonSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            if (!this.bookingSource.isCalendar) return;

            let addToSequence = [
                //{ name: "assessmentType"},
                { name: "student" },
                //{ name: "credit" },
                { name: "purchaseOption" },
                { name: "billingUser" },
                { name: "duration" },
                { name: "location" },
                { name: "online" },
                {
                    name: "teacher",
                    noIndex: !!componentData.assignment && !event.teacherView,
                },
                { name: "instrument" },
                { name: "startDate" },
                { name: "startTime" },
                { name: "room" },
                { name: "experience" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );

            this.$_apis_getTeacherConflicts();
            this.showBookingInPastAlert();
            this.showRecurrenceEndAlert();
        },
        $_options_dragDropRescheduleSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            if (!this.bookingSource.isDragDropReschedule) return;

            let addToSequence = [
                { name: "student" },
                { name: "duration" },
                { name: "location" },
                { name: "online" },
                {
                    name: "instrument",
                    noIndex:
                        !!componentData.assignment &&
                        !event.instrumentView &&
                        formData.instrument,
                },
                {
                    name: "teacher",
                    noIndex: !!componentData.assignment && !event.teacherView,
                },

                { name: "startDate" },
                { name: "startTime" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
        $_options_calendarHoldSteps(
            event,
            formData = {},
            componentData = {},
            sourceStep = 0
        ) {
            let addToSequence = [
                { name: "repeating" },
                { name: "duration" },
                {
                    name: "teacher",
                    noIndex: !!componentData.assignment && !event.teacherView,
                },
                { name: "startDate" },
                { name: "startTime" },
                { name: "room" },
                { name: "experience" },
                { name: "confirm" },
            ];

            this.$_controls_setStepData(
                formData,
                componentData,
                addToSequence,
                sourceStep
            );
        },
    },
};
